import React, { forwardRef, useCallback, useRef, type RefObject } from 'react';

import type {
    DashboardApi,
    DashboardJSON,
    Mode,
} from '@splunk/dashboard-types';

import { CommonHeader } from './HeaderComponents';

export interface HeaderProps {
    definition: DashboardJSON;
    mode: Mode;
    dashboardApi: DashboardApi;
    titleRef?: RefObject<HTMLElement>;
    descRef?: RefObject<HTMLElement>;
    handleRef?: RefObject<HTMLButtonElement>;
}

const DashboardHeader = forwardRef<HTMLDivElement, HeaderProps>(
    ({ definition, mode, dashboardApi, titleRef, descRef, handleRef }, ref) => {
        const definitionRef = useRef(definition);

        definitionRef.current = definition;

        const handleDefinitionChange = useCallback(
            (def: DashboardJSON) => {
                dashboardApi?.updateDefinition(def);
            },
            [dashboardApi]
        );

        const handleTitleCommit = useCallback(
            (val?: string) =>
                handleDefinitionChange({
                    ...definitionRef.current,
                    title: val,
                }),
            [handleDefinitionChange]
        );

        const handleDescriptionChange = useCallback(
            (value?: string) =>
                handleDefinitionChange({
                    ...definitionRef.current,
                    description: value,
                }),
            [handleDefinitionChange]
        );

        const valueTitle = definition.title;
        const valueDesc = definition.description;

        return (
            <CommonHeader
                ref={ref}
                descRef={descRef}
                descriptionValue={valueDesc}
                handleRef={handleRef}
                mode={mode}
                onDescriptionChange={handleDescriptionChange}
                onTitleChange={handleTitleCommit}
                titleRef={titleRef}
                titleValue={valueTitle}
            />
        );
    }
);

export default DashboardHeader;
